/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateTargetStatus$Params {
  targetID?: number;
  statusID?: number;
}

export function UpdateTargetStatus(http: HttpClient, rootUrl: string, params?: UpdateTargetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UpdateTargetStatus.PATH, 'post');
  if (params) {
    rb.query('targetID', params.targetID, {});
    rb.query('statusID', params.statusID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UpdateTargetStatus.PATH = '/api/Supervisor/UpdateTargetStatus';
